export default "__VITE_ASSET__C3Blwsl2__"